// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundOutlinedSvg from "@ant-design/icons-svg/es/asn/FundOutlined";
import AntdIcon from '../components/AntdIcon';

var FundOutlined = function FundOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundOutlinedSvg
  }));
};

FundOutlined.displayName = 'FundOutlined';
export default React.forwardRef(FundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FundOutlined.js
// module id = 1237
// module chunks = 0